package one.healthium.onboarding.di

import one.healthium.onboarding.data.ConditionalScreensFilter
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

actual fun onboardingPlatformModule() = module {
    singleOf(::ConditionalScreensFilter)
}